import React, { Suspense } from "react";

import { useAuth } from "@/contexts/auth/useAuth";
import LinkFooter from "@/features/ui/components/link-footer";
import {
  CtaBanner,
  TrendingEventsPanel,
} from "@/features/ui/util/async-components";

import { Layout } from "../components/ui";

interface PredictionPagePageProps {
  children: React.ReactNode;
}

const PredictionPage: React.FC<PredictionPagePageProps> = ({ children }) => {
  const { currentAccount } = useAuth();

  return (
    <>
      <Layout.Main>
        {children}

        {!currentAccount && (
          <Suspense fallback={null}>
            <CtaBanner key="cta-banner" />
          </Suspense>
        )}
      </Layout.Main>

      <Layout.Aside>
        <Suspense fallback={null}>
          <TrendingEventsPanel />
        </Suspense>

        <LinkFooter key="link-footer" />
      </Layout.Aside>
    </>
  );
};

export default PredictionPage;
